import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import roorReducer from './reducer';

const store = createStore(roorReducer);

export default ({ element }) => <Provider store={store}>{element}</Provider>;
